

module.exports = __webpack_require__.stylable.create(
    "DayDetails2237582526",
    {"classes":{"root":"DayDetails2237582526__root","text":"DayDetails2237582526__text"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "DayDetails2237582526",
    null
);
